import MuiAvatar from '@zenbusiness/zui/Avatar';
import MuiButton from '@zenbusiness/zui/Button';
import { superstyled, alpha } from '@zenbusiness/zui/styles';

export const ProfileButton = superstyled({
  name: 'ProfileButton',
  slot: 'Root',
  tag: MuiButton,
  propsAdded: {
    size: 'small',
    variant: 'outlined'
  },
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.common.transparent,
    borderColor: alpha(theme.palette.border.light, 0.18),
    color: theme.palette.text.white,
    width: '100%',
    '&:hover, &:focus': {
      borderColor: theme.palette.border.light
    },
    [theme.breakpoints.up('sm')]: {
      width: 'auto'
    }
  })
});

export const Content = superstyled({
  name: 'Content',
  slot: 'Root',
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4)
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: theme.spacing(2)
    }
  })
});

export const Avatar = superstyled({
  name: 'Avatar',
  slot: 'Root',
  tag: MuiAvatar,
  propsAdded: {
    variant: 'square'
  },
  styles: ({ theme }) => ({
    border: 'none',
    borderRadius: theme.shape.rounded.md,
    backgroundColor: theme.palette.primary.light,
    height: '2.5rem',
    width: '2.5rem'
  })
});

export const EntityWrapper = superstyled({
  name: 'EntityWrapper',
  slot: 'Root',
  styles: ({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2)
  })
});

export const ProfileWrapper = superstyled({
  name: 'ProfileWrapper',
  slot: 'Root',
  styles: ({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4)
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: theme.spacing(2)
    }
  })
});

export const TextContainer = superstyled({
  name: 'TextContainer',
  slot: 'Root',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0)
  })
});
